import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ProposalViewLayer from "../../components/Proposal/ProposalViewLayer";

const ProposalViewPage = () => {
     return (
          <>
               <MasterLayout>
                    <Breadcrumb title="Proposal View" />
                    <ProposalViewLayer />
               </MasterLayout>
          </>
     );
};

export default ProposalViewPage;
